export default __webpack_public_path__ + "static/media/numberTwell.65489270.png";